module.exports = __webpack_public_path__ + "r-v3/img/sticker_23.62300616.svg";